import logger from '@/utils/logger';
import globalMessage from '../../../store/message';
import {
  buildOptions,
  buildOptionsMedia,
  getEndPoints,
  buildOptionsZip
} from '../../../utils/api-call';
import {
  makeCall
} from '../../../utils/request';
import {
  FETCH_SURVEY_TYPES,
  SET_SURVEY_TYPES,
  FETCH_SURVEY_DEPLOYMENTS,
  SET_SURVEY_DEPLOYMENTS,
  FETCH_SURVEYS_LIST,
  FETCH_QUESTION_LIST,
  FETCH_QUESTION_LIST_NOT_IN_SURVEY,
  FETCH_SURVEY_DETAIL,
  FETCH_SURVEY_DETAIL_BY_UUID,
  FETCH_SURVEY_DETAIL_BY_STEP,
  FETCH_SURVEY_EXTRACT_STATUS,
  FETCH_SURVEY_EXTRACT_FILE,
  FETCH_SURVEY_EXTRACT_INSTANCES_FILE,
  FETCH_SURVEY_PUBLISH_DATETIME,
  FETCH_QUESTION_LIBRARY,
  CREATE_SURVEY_REQUEST,
  CREATE_COPIED_SURVEY_REQUEST,
  UPDATE_SURVEY_FORM_REQUEST,
  UPDATE_SURVEY_REQUEST,
  UPDATE_SURVEY_STATUS_REQUEST,
  QUESTION_CREATE_REQUEST,
  QUESTION_LOGIC_CREATE_REQUEST,
  QUESTION_LOGIC_DELETE_REQUEST,
  DELETE_LOGIC_BY_QUESTION_REQUEST,
  SEARCH_QUESTIONS_FROM_LIBRARY_REQUEST,
  SET_SURVEY_DETAIL,
  SET_SURVEYS_LIST,
  FETCH_SURVEYS_MAP_LIST,
  SET_SURVEYS_MAP_LIST,
  SET_QUESTION_LIST_ACTION,
  SET_QUESTION_LIST,
  FETCH_QUESTION_TYPES,
  FETCH_CHANGE_MODEL,
  SET_CHANGE_MODEL,
  ADD_SELECTED_CHANGE_MODEL,
  SET_SELECTED_CHANGE_MODEL,
  SET_SURVEYS,
  SET_CURRENT_SURVEY,
  SET_ADD_CURRENT_SURVEY,
  ADD_QUESTION_TO_SURVEY,
  SET_ADD_QUESTION_TO_SURVEY,
  SET_QUESTION_TYPES,
  QUESTION_CREATE,
  SET_QUESTION_CREATE,
  QUESTION_ADD_ANSWER,
  QUESTION_REMOVE_ANSWER,
  SET_QUESTION_ADD_ANSWER,
  SET_QUESTION_REMOVE_ANSWER,
  DELETE_SURVEY,
  SET_DELETE_SURVEY,
  DELETE_QUESTION,
  SET_DELETE_QUESTION,
  DELETE_QUESTION_BY_SURVEY,
  SET_CURRENT_PRACTICE_STEP,
  SET_ADD_CURRENT_PRACTICE_STEP,
  RESET_CURRENT_SURVEY,
  SET_RESET_CURRENT_SURVEY,
  SET_RESET_QUESTION_LIST_ACTION,
  SET_RESET_QUESTION_LIST,
  FETCH_SURVEY_GROUP_QUESTION_BY_TITLE,
  CREATE_SURVEY_GROUP_QUESTION,
  UPDATE_GROUP_QUESTION_ADD_REQUEST,
  UPDATE_GROUP_QUESTION_ADD,
  UPDATE_GROUP_QUESTION_REMOVE_REQUEST,
  UPDATE_GROUP_QUESTION_REMOVE,
  UPDATE_GROUP_QUESTIONS_REQUEST,
  ADD_QUESTIONS_FROM_LIBRARY_REQUEST,
  CHECK_VALID_LOGIC_REQUEST,
  REORDER_QUESTION_REQUEST,
  SET_COPY_SURVEY_REQUEST,
  SET_COPY_SURVEY,
  CREATE_SURVEY_SCORE_LOGIC,
  FETCH_SURVEY_TOTAL_SCORE,
  FETCH_PRELOAD_VARIABLE,
  ADD_PRELOAD_VARIABLE,
  FETCH_SOURCE_VARIABLE,
  FETCH_FIELD_VARIABLE,
  UPDATE_PRELOAD_VARIABLE,
  DELETE_PRELOAD_VARIABLE,
  ADD_CALCULATE_VARIABLE,
  FETCH_CALCULATE_VARIABLE,
  UPDATE_CALCULATE_VARIABLE,
  ADD_PAGE_BREAK,
  UPDATE_PAGE_BREAK,
  DELETE_PAGE_BREAK,
  SET_PAGE_BREAK_LIST,
  DELETE_CALCULATE_VARIABLE,
  SET_CALCULATE_VARIABLE_LIST,
  SET_SOURCE_OPTIONS,
  SET_PRELOAD_VARIABLE,
  ADD_PAGE_BREAK_RESOURCES,
  FETCH_SURVEY_HPA_SCORE_CATEGORIES,
  SET_SURVEY_HPA_SCORE_CATEGORIES
} from './constants';

import {
  completedTabSurvey,
  doneQuestionTypesContent,
  initQuestionTypesContent,
  percentSettings,
  sliderSettings,
  flourishDomains,
  questionTypes
} from './initialSurveyData';
import questionConstants from '../../../views/questions/constants';

import _ from 'lodash';
const specialType = {
  FLOURING_INDEX: 'FLOURING_INDEX'
};

export const state = {
  calculateVariable: [],
  currentSurvey: {
    questions: []
  },
  surveys: [], // list of survey types
  surveyLists: [], // list of all surveys
  surveyTypes: [],
  questionTypes: [],
  questions: [], // all questions in survey
  surveyQuestions: [], // all questions in survey
  surveyDeployments: [],
  transformativeChangeModel: null,
  selectedChangeModel: null,
  doneQuestionTypesContent: doneQuestionTypesContent,
  surveyMaps: null,
  currentPracticeStep: null,
  isLoadingStatus: {
    isLoadingRequest: false,
    isLoadingSurveyMapRequest: false,
    isLoadingChangeModelRequest: false,
    isLoadingGroupQuestion: false
  },
  copiedSurvey: null,
  questionCategories: [],
  sourceList: [],
  preloadVariableList: [],
  pageBreakList: [],
  hpaScoreCategories: []
};

const questionTypeMap = new Map();
questionTypeMap.set(questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE, 'Multiple Choice');
questionTypeMap.set(questionConstants.QUESTION_TYPES.ONE_FIVE_SCALE_MULTIPLE_CHOICE, '1-5 scale multiple choice');
questionTypeMap.set(questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE_PICK_LIST, 'Pick List');
questionTypeMap.set(questionConstants.QUESTION_TYPES.SATISFACTION, 'Satisfaction');
questionTypeMap.set(questionConstants.QUESTION_TYPES.SATISFACTION_LIKERT, 'Likert');
questionTypeMap.set(questionConstants.QUESTION_TYPES.RATING_SATISFACTION, 'Rating Satisfaction');
questionTypeMap.set(questionConstants.QUESTION_TYPES.SATISFACTION_RATING_THING, 'Rating Things');
questionTypeMap.set(questionConstants.QUESTION_TYPES.PERCENTAGE, 'Percentage Scale');
questionTypeMap.set(questionConstants.QUESTION_TYPES.PERCENTAGE_SCALE, 'Rating a percentage of something');
questionTypeMap.set(questionConstants.QUESTION_TYPES.MULTIPLE_SELECT, 'Multi-Select');
questionTypeMap.set(questionConstants.QUESTION_TYPES.MULTIPLE_SELECT_MORE_THAN_ONE_ANSWER, 'Allow users to pick more than one answer');
questionTypeMap.set(questionConstants.QUESTION_TYPES.STACK_RANKING, 'Stack Ranking');
questionTypeMap.set(questionConstants.QUESTION_TYPES.STACK_RANKING_HIGH_TOP, 'Highest ranking at top');
questionTypeMap.set(questionConstants.QUESTION_TYPES.STACK_RANKING_LOW_BOTTOM, 'Lowest ranking at bottom');
questionTypeMap.set(questionConstants.QUESTION_TYPES.OPEN_TEXT, 'Open Text');
questionTypeMap.set(questionConstants.QUESTION_TYPES.OPEN_TEXT_SHORT_ANSWER, 'Short Answer (character limit 255)');
questionTypeMap.set(questionConstants.QUESTION_TYPES.OPEN_TEXT_LONG_ANSWER, 'Long Answer (character limit 2000)');
questionTypeMap.set(questionConstants.QUESTION_TYPES.OPEN_TEXT_NUMERIC_ANSWER, 'Numeric Answer');

function validateNeedInputAnwser (doneContentType, questionTypeId) {
  doneContentType.contentRight[0].needInputAnswer = false;
  switch (questionTypeId) {
    case questionConstants.QUESTION_TYPES.OPEN_TEXT_NUMERIC_ANSWER:
    case questionConstants.QUESTION_TYPES.SATISFACTION_RATING_THING:
    case questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE:
    case questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE_PICK_LIST:
    case questionConstants.QUESTION_TYPES.MULTIPLE_SELECT_MORE_THAN_ONE_ANSWER:
    case questionConstants.QUESTION_TYPES.STACK_RANKING_HIGH_TOP:
    case questionConstants.QUESTION_TYPES.STACK_RANKING_LOW_BOTTOM: {
      doneContentType.contentRight[0].needInputAnswer = true;
      break;
    }
  }
  return doneContentType;
}

function generateEmptyQuestion (currentState) {
  currentState.currentSurvey.surveyQuestions = [];
  const contentType = _.cloneDeep(initQuestionTypesContent);
  const question = {
    title: '',
    question: '',
    surveyQuestionAnswers: [],
    selectedQuestionAnswers: [],
    questionResponse: [],
    required: false,
    enableProgramSatisfaction: false,
    fixedRangeDateStatus: false,
    type: 0,
    edit: false,
    preview: false,
    completed: false,
    questionTypesContent: contentType,
    disableCreateQuestionButton: true,
    domainId: null
  };
  currentState.questions.push(question);
}
// TODO add calculate variable
function generateCalculateVariable (currentStateQuestion, item) {
  const contentType = _.cloneDeep(initQuestionTypesContent);
  const hpaScoreItem = item.hpaScore || {};
  const selectedTags = hpaScoreItem && hpaScoreItem.tags && hpaScoreItem.tags.length > 0 ? hpaScoreItem.tags : [];

  let calculateVariable = {
    title: item.name,
    question: '',
    surveyQuestionAnswers: [],
    selectedQuestionAnswers: [],
    questionResponse: [],
    required: false,
    enableProgramSatisfaction: false,
    fixedRangeDateStatus: false,
    type: 'CALCULATION_VARIABLE',
    edit: false,
    completed: true,
    questionTypesContent: contentType,
    disableCreateQuestionButton: true,
    domainId: null,
    calculateVariable: true,
    variableName: item.name,
    variableFomular: item.calculation,
    orderIndex: item.orderIndex,
    explanation: item.explanation,
    showToEndUser: item.showToEndUser,
    selectedHpaCategoryId: hpaScoreItem && hpaScoreItem.category ? hpaScoreItem.category.id : null,
    calculatedScoreName: hpaScoreItem && hpaScoreItem.category ? hpaScoreItem.category.title : '',
    hpaScoreId: hpaScoreItem.id,
    scoreTitle: hpaScoreItem.title,
    scoreDescription: hpaScoreItem.description,
    riskText: hpaScoreItem.riskText,
    scoreType: hpaScoreItem.scoreType || '',
    masterScore: hpaScoreItem.masterScore,
    binaryVariableId: hpaScoreItem.binaryVariableId,
    selectedMethodCalculationScore: hpaScoreItem.scoreType,
    selectedCalculationScore: hpaScoreItem.isNegativeScore ? 0 : 1,
    id: item.id,
    preview: true,
    selectedTagId: selectedTags.length > 0 ? selectedTags[0].tagUuid : null, // TODO need to work multiple tags later
    selectedHpaTagId: selectedTags.length > 0 ? selectedTags[0].id : null, // TODO need to work multiple tags later
    selectedTags: selectedTags
  };
  if (hpaScoreItem.masterScore) {
    calculateVariable.selectedHpaCategoryId = hpaScoreItem.masterScore.id;
  }
  currentStateQuestion.push(calculateVariable);
}

function addPageBreakToSurveyQuestions (currentStateQuestions, pageBreak) {
  const contentType = _.cloneDeep(initQuestionTypesContent);
  const item = {
    title: 'Page Break',
    question: '',
    surveyQuestionAnswers: [],
    selectedQuestionAnswers: [],
    questionResponse: [],
    required: false,
    enableProgramSatisfaction: false,
    fixedRangeDateStatus: false,
    type: 'PAGE_BREAK',
    edit: false,
    completed: true,
    questionTypesContent: contentType,
    disableCreateQuestionButton: true,
    domainId: null,
    pageBreak: true,
    transitionText: pageBreak.transitionText,
    transitionButtonText: pageBreak.transitionButtonText,
    orderIndex: pageBreak.orderIndex,
    id: pageBreak.id,
    resources: pageBreak.resources,
    preview: true
  };
  currentStateQuestions.push(item);
}

function questionOrderIndex (currentState) {
  currentState.questions.sort((a, b) => { return a.orderIndex - b.orderIndex; });
}

function standardSurveyData (state, survey) {
  if (state.currentPracticeStep && state.currentPracticeStep.id) {
    survey.stepId = state.currentPracticeStep.id;
    survey.stepTitle = state.currentPracticeStep.stepTitle;
  }
  survey.surveyName = survey.title;
  survey.surveyDescription = survey.description;
  survey.surveyRef = survey.reference;
  survey.enableAduroIndex = survey.specialType === specialType.FLOURING_INDEX;
  survey.completedTabs = _.cloneDeep(completedTabSurvey);
  survey.completedTabs.forEach(tab => {
    switch (tab.step) {
      case 'SUBMIT_SURVEY':
        tab.subHeader = survey.category;
        tab.selectedItem = {
          id: survey.categoryId,
          title: survey.category
        };
        break;
      case 'CREATE_QUESTION':
        break;
    }
  });
  return resetSurvey(survey);
}

function resetSurvey (survey) {
  survey.groupQuestionMode = false;
  const size = survey.surveyQuestions && survey.surveyQuestions.length > 0 ? survey.surveyQuestions.length : 0;
  for (let i = 0; i < size; i++) {
    const q = survey.surveyQuestions[i];
    if (q.groupQuestions) {
      q.groupQuestionMode = true;
      q.groupQuestions.forEach(q => {
        q.expand = false;
        q.groupQuestionMode = !survey.groupQuestionMode;
        q.selectedGroup = !survey.groupQuestionMode;
      });
    } else {
      q.expand = !survey.groupQuestionMode;
    }
  }
  return survey;
}

function standardSurveyQuestion (currentState, currentQuestion) {
  const questionType = currentQuestion.type;
  const doneContentType = validateNeedInputAnwser(_.cloneDeep(currentState.doneQuestionTypesContent), questionType);
  doneContentType.contentLeft.forEach((o) => {
    o.currentQuestionType = {
      id: questionType,
      name: questionTypeMap.get(questionType)
    };
  });
  doneContentType.contentRight[0].name = questionTypeMap.get(currentQuestion.type);
  if (currentQuestion.text) {
    currentQuestion.question = currentQuestion.text;
  }
  currentQuestion.selectedChangeModelId = currentQuestion.generalTypeId;
  currentQuestion.selectedChangeModel = currentQuestion.generalType;
  currentQuestion.questionTypesContent = doneContentType;
  currentQuestion.historyNotes = currentQuestion.surveyQuestionComments;
  currentQuestion.completed = true;
  currentQuestion.edit = false;
  currentQuestion.preview = true;
  if (currentQuestion.surveyQuestionAnswers) {
    currentQuestion.surveyQuestionAnswers.forEach((o) => {
      o.title = o.answerTitle;
      o.text = o.answerText;
      if (o.defaultValue) {
        o.value = o.defaultValue;
      }

      if (o.unit) {
        o.questionUnit = o.unit;
      }
      if (typeof (o.numberDecimalPlace) !== 'undefined') {
        o.questionDecimal = o.numberDecimalPlace;
      }
      if (o.minValue >= 0) {
        o.minNumeric = o.minValue;
      }
      if (o.maxValue) {
        o.maxNumeric = o.maxValue;
      }

      if (o.maxLength) {
        currentQuestion.characters = o.maxLength;
      }
      if (o.preloadedVariable) {
        o.preloadedVariableId = o.preloadedVariable.id;
        o.preloadVariableItem = o.preloadedVariable.name;
      } else {
        o.preloadedVariableId = null;
        o.preloadVariableItem = null;
      }
    });
  }
  if (currentQuestion.historyNotes && currentQuestion.historyNotes.length > 0) {
    currentQuestion.historyNotes.forEach((o) => {
      o.message = o.commentText;
      o.dateTime = o.createdAt * 1000;
    });
  }
  switch (questionType) {
    case questionConstants.QUESTION_TYPES.SLIDER:
      // TODO user sliderSetting instead of percentSettings
      currentQuestion.settings = _.cloneDeep(sliderSettings);
      if (currentQuestion.surveyQuestionAnswers && currentQuestion.surveyQuestionAnswers.length > 0) {
        currentQuestion.rating = currentQuestion.surveyQuestionAnswers[0].defaultValue;
      }
      currentQuestion.flourishDomains = _.cloneDeep(flourishDomains);
      break;
    case questionConstants.QUESTION_TYPES.PERCENTAGE_SCALE:
      currentQuestion.settings = _.cloneDeep(percentSettings);
      if (currentQuestion.surveyQuestionAnswers && currentQuestion.surveyQuestionAnswers.length > 0) {
        currentQuestion.rating = currentQuestion.surveyQuestionAnswers[0].defaultValue;
      }
      break;
    case questionConstants.QUESTION_TYPES.OPEN_TEXT_NUMERIC_ANSWER:
      currentQuestion.validDecimalPlace = true;
      break;
    case questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE_DATE_PICK:
      currentQuestion.initDateRangeStart = currentQuestion.dateRangeStart;
      currentQuestion.initDateRangeEnd = currentQuestion.dateRangeEnd;
      break;
  }
  return currentQuestion;
}

function findSubQuestionsInGroup (currentState, group) {
  const groupIndex = currentState.questions.findIndex(q => q.groupId === group.groupId);
  if (groupIndex === -1) return [];
  return currentState.questions[groupIndex].groupQuestions;
}

async function fetchCalculateVariable ({commit, state}, options) {
  return new Promise((resolve, reject) => {
    makeCall(
      getEndPoints().variables.fetchCalculateVariable.replace('{surveyId}', options.surveyId),
      buildOptions('GET'), commit)
      .then(response => {
        if (response || response.data) {
          commit(SET_CALCULATE_VARIABLE_LIST, response || response.data);
        }
        resolve(response);
      }, error => {
        logger.error('error =', error);
        state.isLoadingStatus.isLoadingRequest = false;
        error.data = {
          message: 'Can not fetch calculate variable'
        };
        reject(error);
      });
  });
}

async function fetchPageBreak ({commit, state}, options) {
  return new Promise((resolve, reject) => {
    makeCall(
      getEndPoints().pageBreak.fetchPageBreak.replace('{surveyId}', options.surveyId),
      buildOptions('GET'), commit)
      .then(response => {
        if (response || response.data) {
          commit(SET_PAGE_BREAK_LIST, response || response.data);
        }
        resolve(response);
      }, error => {
        logger.error('error =', error);
        state.isLoadingStatus.isLoadingRequest = false;
        error.data = {
          message: 'Can not fetch calculate variable'
        };
        reject(error);
      });
  });
}

async function fetchFieldVariable ({commit, state}, options) {
  return new Promise((resolve, reject) => {
    makeCall(
      getEndPoints().variables.fetchFieldVariable.replace('{sourceId}', options.sourceId),
      buildOptions('GET'), commit)
      .then(response => {
        resolve(response);
      }, error => {
        logger.error('error =', error);
        state.isLoadingStatus.isLoadingRequest = false;
        error.data = {
          message: 'Can not fetch field variable'
        };
        reject(error);
      });
  });
}

async function fetchSourceVariable ({commit, state}) {
  return new Promise((resolve, reject) => {
    makeCall(
      getEndPoints().variables.fetchSourceVariable,
      buildOptions('GET'), commit)
      .then(response => {
        const sourceList = response.data ? response.data : response;
        commit(SET_SOURCE_OPTIONS, sourceList);
        resolve(sourceList);
      }, error => {
        logger.error('error =', error);
        state.isLoadingStatus.isLoadingRequest = false;
        error.data = {
          message: 'Can not fetch source variable'
        };
        reject(error);
      });
  });
}

async function fetchPreloadVariable ({commit, state}, options) {
  return new Promise((resolve, reject) => {
    makeCall(
      getEndPoints().variables.fetchPreloadVariable.replace('{surveyId}', options.surveyId),
      buildOptions('GET'), commit)
      .then(response => {
        const data = response.data ? response.data : response;
        commit(SET_PRELOAD_VARIABLE, data);
        resolve(response);
      }, error => {
        logger.error('error =', error);
        state.isLoadingStatus.isLoadingRequest = false;
        error.data = {
          message: 'Can not fetch Preloaded Variables'
        };
        reject(error);
      });
  });
}

export const actions = {
  [UPDATE_CALCULATE_VARIABLE] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.updateCalculateVariable.replace('{id}', options.id),
        buildOptions('PUT', options), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not update calculate variable'
          };
          reject(error);
        });
    });
  },
  [ADD_PAGE_BREAK] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().pageBreak.addPageBreak,
        buildOptions('POST', options), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not add page break'
          };
          reject(error);
        });
    });
  },
  [ADD_PAGE_BREAK_RESOURCES] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().pageBreak.addPageBreakResources.replace('{mediaType}', options.mediaType),
        buildOptionsMedia('POST', options.data), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not add resource'
          };
          reject(error);
        });
    });
  },
  [UPDATE_PAGE_BREAK] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().pageBreak.updatePageBreak.replace('{id}', options.id),
        buildOptions('PUT', options), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not update page break'
          };
          reject(error);
        });
    });
  },
  [DELETE_PAGE_BREAK] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().pageBreak.deletePageBreak.replace('{id}', options.id),
        buildOptions('DELETE'), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not delete page break'
          };
          reject(error);
        });
    });
  },
  [DELETE_CALCULATE_VARIABLE] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.deleteCalculateVariable.replace('{id}', options.id),
        buildOptions('DELETE'), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not delete calculate variable'
          };
          reject(error);
        });
    });
  },
  [FETCH_CALCULATE_VARIABLE] ({commit, state}, options) {
    return fetchCalculateVariable({commit, state}, options);
  },
  [ADD_CALCULATE_VARIABLE] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.addCalculateVariable,
        buildOptions('POST', options), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not add calculate variable'
          };
          reject(error);
        });
    });
  },
  [DELETE_PRELOAD_VARIABLE] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.deletePreloadVariable.replace('{id}', options.sourceId),
        buildOptions('DELETE'), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not delete Preloaded Variables'
          };
          reject(error);
        });
    });
  },
  [UPDATE_PRELOAD_VARIABLE] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.updatePreloadVariable.replace('{id}', options.id),
        buildOptions('PUT', options), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not update Preloaded Variables'
          };
          reject(error);
        });
    });
  },
  [FETCH_FIELD_VARIABLE] ({commit, state}, options) {
    return fetchFieldVariable({commit, state}, options);
  },
  [FETCH_SOURCE_VARIABLE] ({commit, state}) {
    return fetchSourceVariable({commit, state});
  },
  [ADD_PRELOAD_VARIABLE] ({commit, state}, options) {
    let payload = {
      name: options.variableName,
      field: {id: options.field},
      survey: {id: options.surveyId}
    };
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().variables.addPreloadVariable,
        buildOptions('POST', payload), commit)
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not add Preloaded Variables'
          };
          reject(error);
        });
    });
  },
  [FETCH_PRELOAD_VARIABLE] ({commit, state}, options) {
    return fetchPreloadVariable({commit, state}, options);
  },
  [CREATE_SURVEY_SCORE_LOGIC] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    let payload = {
      surveyScoreLogics: options.surveyScoringLogics
    };
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.surveyLogics.replace('{surveyId}', options.surveyId),
        buildOptions('POST', payload), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(true);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not create survey score logic'
          };
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_TOTAL_SCORE] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.surveyLogics.replace('{surveyId}', options),
        buildOptions('GET'), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Can not fetch total score'
          };
          reject(error);
        });
    });
  },
  [CREATE_SURVEY_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.main,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          if (response.survey) {
            state.currentSurvey = _.extend(state.currentSurvey, response.survey);
            commit(SET_SURVEY_DETAIL, state.currentSurvey);
            resolve(state.currentSurvey);
          }
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'Survey cannot be saved. There is something wrong, please contact our support for more detail.'
          };
          reject(error);
        });
    });
  },
  [CREATE_COPIED_SURVEY_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.copySurvey,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          if (response.survey) {
            state.copiedSurvey = null;
            state.currentSurvey = _.extend(state.currentSurvey, response.survey);
            commit(SET_SURVEY_DETAIL, resetSurvey(state.currentSurvey));
            resolve(state.currentSurvey);
          }
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [UPDATE_SURVEY_FORM_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.surveyForm.replace(':id', state.currentSurvey.id),
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [UPDATE_SURVEY_REQUEST] ({commit, state}) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    state.currentSurvey.surveyQuestions = state.questions;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detail.replace(':id', state.currentSurvey.id),
        buildOptions('POST', state.currentSurvey), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          state.questions.forEach(q => {
            q.addedToSurvey = true;
          });
          commit(SET_ADD_QUESTION_TO_SURVEY);
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [UPDATE_SURVEY_STATUS_REQUEST] ({commit, state}, options) {
    delete options.data.surveyQuestions;
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detail.replace(':id', options.data.id),
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [ADD_QUESTION_TO_SURVEY] ({commit}) {
    return commit(SET_ADD_QUESTION_TO_SURVEY);
  },
  [QUESTION_CREATE_REQUEST] ({commit}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        options.currentQuestion.id ? getEndPoints().question.detail.replace('{surveyQuestionId}', options.currentQuestion.id) : getEndPoints().question.main,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          options.currentQuestion.id = response.surveyQuestion.id;
          options.currentQuestion.orderIndex = response.surveyQuestion.orderIndex;
          resolve(options.currentQuestion);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_TYPES] ({ commit, state }) {
    if (state.surveyTypes && state.surveyTypes.length > 0) {
      return;
    }
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.types,
        buildOptions(), commit)
        .then(response => {
          const result = response.data ? response.data.surveyTypes : response.surveyTypes;
          commit(SET_SURVEY_TYPES, result);
          resolve(response.surveyTypes);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_DEPLOYMENTS] ({ commit, state }) {
    if (state.surveyDeployments && state.surveyDeployments.length > 0) {
      return Promise.resolve(state.surveyDeployments);
    }
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.deployments,
        buildOptions(), commit)
        .then(response => {
          const result = response.data ? response.data.surveyDeployments : response.surveyDeployments;
          commit(SET_SURVEY_DEPLOYMENTS, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_SURVEYS_LIST] ({ commit }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.main,
        buildOptions('GET', options, null, { signal: options?.signal }), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          commit(SET_SURVEYS_LIST, response.surveys);
          resolve(response);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_SURVEYS_MAP_LIST] ({ commit, state }) {
    if (state.isLoadingStatus.isLoadingSurveyMapRequest) return;
    state.isLoadingStatus.isLoadingSurveyMapRequest = true;
    const mapUrl = getEndPoints().survey.map + '?surveyId=' + state.currentSurvey.id;
    return new Promise((resolve, reject) => {
      makeCall(
        mapUrl,
        buildOptions(), commit)
        .then(response => {
          state.isLoadingStatus.isLoadingSurveyMapRequest = false;
          const result = response.data ? response.data : response;
          resolve(result);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingSurveyMapRequest = false;
          reject(error);
        });
    });
  },
  [FETCH_QUESTION_LIST] ({ commit, state }) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.main,
        buildOptions(), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          let allquestions = response.surveyQuestions;
          if (state.questions) {
            allquestions = _.differenceBy(response.surveyQuestions, state.questions, 'id');
          }
          resolve(allquestions);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [FETCH_QUESTION_LIST_NOT_IN_SURVEY] ({ commit, state }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.questionsNotInSurvey.replace('{surveyId}', options.surveyId),
        buildOptions('GET', options), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          resolve(response);
        }, error => {
          logger.error('error =', error);
          reject(error);
        });
    });
  },
  [FETCH_QUESTION_LIBRARY] ({ commit, state }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.questionLibrary,
        buildOptions('GET', options), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          resolve(response);
        }, error => {
          logger.error('error =', error);
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_DETAIL] ({ commit, state }, options) {
    commit(SET_RESET_QUESTION_LIST);
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detail.replace(':id', options.surveyId),
        buildOptions(), commit)
        .then(response => {
          let survey = response.data ? response.data.survey : response.survey;
          survey = standardSurveyData(state, survey);
          commit(SET_SURVEY_DETAIL, survey);
          resolve(survey);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_PUBLISH_DATETIME] ({ commit, state }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detail.replace(':id', options.surveyId),
        buildOptions(), commit)
        .then(response => {
          let survey = response.data ? response.data.survey : response.survey;
          resolve(survey);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_DETAIL_BY_UUID] ({ commit, state }, options) {
    commit(SET_RESET_QUESTION_LIST);
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detailByUuid
          .replace(':id', options.surveyUuid)
          .replace('{contactId}', options.contactId),
        buildOptions('GET', undefined, undefined, { skipAuthen: true }),
        commit
      )
        .then(response => {
          let survey = response.data ? response.data.survey : response.survey;
          survey = standardSurveyData(state, survey);
          commit(SET_SURVEY_DETAIL, survey);
          resolve(survey);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_DETAIL_BY_STEP] ({ commit, state }, options) {
    commit(SET_RESET_QUESTION_LIST);
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detailByStep.replace(':id', options.surveyId).replace(':stepId', options.stepId),
        buildOptions(), commit)
        .then(async response => {
          let survey = response.data ? response.data.survey : response.survey;
          survey = standardSurveyData(state, survey);
          await fetchCalculateVariable({commit, state}, options);
          await fetchPageBreak({commit, state}, options);
          commit(SET_SURVEY_DETAIL, survey);
          resolve(survey);
        }, error => {
          reject(error);
        });
    });
  },
  [RESET_CURRENT_SURVEY] ({ commit, state }, resetCurrentSurvey) {
    commit(SET_RESET_CURRENT_SURVEY, resetCurrentSurvey);
  },
  [FETCH_QUESTION_TYPES] ({ commit }) {
    return commit(SET_QUESTION_TYPES, questionTypes);
  },
  [FETCH_CHANGE_MODEL] ({ commit, state }) {
    if (state.isLoadingStatus.isLoadingChangeModelRequest) {
      return;
    }
    state.isLoadingStatus.isLoadingChangeModelRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().general.types.transformatives,
        buildOptions(), commit)
        .then(response => {
          state.isLoadingStatus.isLoadingChangeModelRequest = false;
          commit(SET_CHANGE_MODEL, response.data ? response.data.generalTypes : response.generalTypes);
          resolve(response);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingChangeModelRequest = false;
          reject(error);
        });
    });
  },
  [QUESTION_LOGIC_CREATE_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.logic,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [ADD_SELECTED_CHANGE_MODEL] ({ commit }, item) {
    return commit(SET_SELECTED_CHANGE_MODEL, item);
  },
  [SET_CURRENT_SURVEY] ({commit}, item) {
    return commit(SET_ADD_CURRENT_SURVEY, item);
  },
  [SET_COPY_SURVEY_REQUEST] ({commit}, item) {
    return commit(SET_COPY_SURVEY, item);
  },
  [SET_CURRENT_PRACTICE_STEP] ({commit}, item) {
    return commit(SET_ADD_CURRENT_PRACTICE_STEP, item);
  },
  [QUESTION_CREATE] ({commit}, item) {
    return commit(SET_QUESTION_CREATE, item);
  },
  [UPDATE_GROUP_QUESTION_ADD_REQUEST] ({commit}, item) {
    return commit(UPDATE_GROUP_QUESTION_ADD, item);
  },
  [UPDATE_GROUP_QUESTION_REMOVE_REQUEST] ({commit}, item) {
    return commit(UPDATE_GROUP_QUESTION_REMOVE, item);
  },
  [QUESTION_ADD_ANSWER] ({commit}, item) {
    return commit(SET_QUESTION_ADD_ANSWER, item);
  },
  [QUESTION_REMOVE_ANSWER] ({commit}, item) {
    return commit(SET_QUESTION_REMOVE_ANSWER, item);
  },
  [DELETE_SURVEY] ({commit, state}, item) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.detail.replace(':id', item.id),
        buildOptions('DELETE'), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          commit(SET_DELETE_SURVEY, item);
          resolve(item);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [DELETE_QUESTION] ({commit, state}, item) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.detail.replace('{surveyQuestionId}', item.id),
        buildOptions('DELETE'), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          commit(SET_DELETE_QUESTION, item);
          resolve(item);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [DELETE_QUESTION_BY_SURVEY] ({commit, state}, item) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.question.detail.replace('{surveyId}', item.surveyId).replace('{questionId}', item.questionId),
        buildOptions('DELETE'), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          const surveyQuestions = response.surveyQuestions;
          state.isLoadingStatus.isLoadingRequest = false;
          for (let i = 0; i < surveyQuestions.length; i++) {
            const currentQuestion = surveyQuestions[i];
            currentQuestion.addedToSurvey = true;
            currentQuestion.surveyId = item.surveyId;
            if (currentQuestion.groupQuestions) {
              for (let j = 0; j < currentQuestion.groupQuestions.length; j++) {
                const subQuestion = currentQuestion.groupQuestions[j];
                subQuestion.addedToSurvey = true;
                subQuestion.surveyId = item.surveyId;
                subQuestion.expand = true;
                standardSurveyQuestion(state, subQuestion);
              }
            } else {
              currentQuestion.expand = true;
              standardSurveyQuestion(state, currentQuestion);
            }
          }
          state.questions = surveyQuestions;
          generateEmptyQuestion(state);
          state.currentSurvey.questions = state.questions;
          state.surveyQuestions = _.cloneDeep(state.questions);
          resolve(item);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [QUESTION_LOGIC_DELETE_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.logic,
        buildOptions('DELETE', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [DELETE_LOGIC_BY_QUESTION_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.deleteByQuestion,
        buildOptions('DELETE', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_GROUP_QUESTION_BY_TITLE] ({ commit, state }, item) {
    if (state.isLoadingStatus.isLoadingGroupQuestion) return;
    state.isLoadingStatus.isLoadingGroupQuestion = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.groupQuestion.groupsByTitle.replace(':id', item.surveyId),
        buildOptions(), commit)
        .then(response => {
          state.isLoadingStatus.isLoadingGroupQuestion = false;
          const result = response.data ? response.data.surveyGroups : response.surveyGroups;
          state.currentSurvey.groups = result;
          commit(SET_ADD_CURRENT_SURVEY, state.currentSurvey);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingGroupQuestion = false;
          reject(error);
        });
    });
  },
  [CREATE_SURVEY_GROUP_QUESTION] ({ commit, state }, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.groupQuestion.groups,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          if (state.currentSurvey.groups) {
            const existingGroupIndex = state.currentSurvey.groups.findIndex(g => g.id === response.surveyGroup.id);
            if (existingGroupIndex === -1) {
              state.currentSurvey.groups.push(response.surveyGroup);
            }
            commit(SET_ADD_CURRENT_SURVEY, state.currentSurvey);
          }
          resolve(response.surveyGroup);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [UPDATE_GROUP_QUESTIONS_REQUEST] ({ commit, state }, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.groupQuestion.groupQuestions,
        buildOptions('POST', options.data), commit)
        .then(response => {
          if (response.doubleClick) {
            return resolve(null);
          }
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error=', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [ADD_QUESTIONS_FROM_LIBRARY_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.addFromLibrary,
        buildOptions('POST', options), commit)
        .then(response => {
          state.isLoadingStatus.isLoadingRequest = false;
          resolve(response);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          reject(error);
        });
    });
  },
  [CHECK_VALID_LOGIC_REQUEST] ({commit, state}, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.checkValidLogic,
        buildOptions('POST', options.data), commit)
        .then(response => {
          const result = response.data !== undefined && response.data !== null ? response.data : response;
          resolve(result);
        }, error => {
          logger.error('error =', error);
          reject(error);
        });
    });
  },
  [REORDER_QUESTION_REQUEST] ({commit, state}, options) {
    if (state.isLoadingStatus.isLoadingRequest) return;
    state.isLoadingStatus.isLoadingRequest = true;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.reorderQuestions.replace('{surveyId}', options.surveyId),
        buildOptions('POST', options.data), commit)
        .then(response => {
          state.isLoadingStatus.isLoadingRequest = false;
          const result = response.data !== undefined && response.data !== null ? response.data : response;
          resolve(result);
        }, error => {
          logger.error('error =', error);
          state.isLoadingStatus.isLoadingRequest = false;
          error.data = {
            message: 'There is something wrong, the questions cannot re-order!'
          };
          reject(error);
        });
    });
  },
  [SEARCH_QUESTIONS_FROM_LIBRARY_REQUEST] ({ commit, state }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().question.searchFromLibrary
          .replace('{1}', options.title)
          .replace('{2}', options.filterBy),
        buildOptions(), commit)
        .then(response => {
          resolve(response);
        }, error => {
          reject(error);
        });
    });
  },
  [SET_QUESTION_LIST_ACTION] ({ commit, state }, questions) {
    commit(SET_QUESTION_LIST, questions);
  },
  [SET_RESET_QUESTION_LIST_ACTION] ({ commit }) {
    commit(SET_RESET_QUESTION_LIST);
  },
  [FETCH_SURVEY_EXTRACT_STATUS] ({ commit, state }, options) {
    let fullUrl = getEndPoints().survey.extract.status.replace(':id', options.surveyId);
    if (options.fromDate && options.endDate) {
      fullUrl += `?fromDate=${options.fromDate}&endDate=${options.endDate}&extractType=${options.extractType}`;
    }
    return new Promise((resolve, reject) => {
      makeCall(
        fullUrl,
        buildOptions(), commit)
        .then(response => {
          resolve(response);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_EXTRACT_FILE] ({ commit, state }, options) {
    const params = `?surveyId=${options.surveyId}&fromDate=${options.fromDate}&endDate=${options.endDate}`;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.extract.download + params,
        buildOptionsZip(), commit)
        .then(response => {
          resolve(response);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_EXTRACT_INSTANCES_FILE] ({ commit, state }, options) {
    const params = `?surveyId=${options.surveyId}&fromDate=${options.fromDate}&endDate=${options.endDate}`;
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().survey.extract.downloadInstances + params,
        buildOptions(), commit)
        .then(response => {
          resolve(response);
        }, error => {
          reject(error);
        });
    });
  },
  [FETCH_SURVEY_HPA_SCORE_CATEGORIES] ({ commit, state }) {
    console.error('[HPA categories] action start', {
      existingLength: state.hpaScoreCategories ? state.hpaScoreCategories.length : 0
    });
    if (state.hpaScoreCategories && state.hpaScoreCategories.length > 1) {
      console.error('[HPA categories] using cached categories', {
        cachedLength: state.hpaScoreCategories.length
      });
      return state.hpaScoreCategories;
    }
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().hpa.categories,
        buildOptions(), commit)
        .then(response => {
          console.error('[HPA categories] raw response', response);
          let calculationCategories = [{
            value: null,
            text: globalMessage.questionContent.left.variables.calcuation.textChooseCategory,
            defaultText: globalMessage.questionContent.left.variables.calcuation.textChooseCategory,
            connectText: globalMessage.questionContent.left.variables.calcuation.textChooseScoreToConnect
          }];
          const candidates = [
            response,
            response && response.body,
            response && response.data,
            response && response.data && response.data.body,
            response && response.data && response.data.data,
            response && response.data && response.data.data && response.data.data.body
          ];
          const result = candidates.find(item => Array.isArray(item)) || [];
          console.error('[HPA categories] normalized result', {
            resultLength: result.length,
            firstItem: result[0]
          });
          if (result && result.length > 0) {
            result.forEach(r => {
              r.value = r.id;
              r.text = r.title || r.categoryName || r.name || r.text;
            });
            calculationCategories = calculationCategories.concat(result);
          }
          commit(SET_SURVEY_HPA_SCORE_CATEGORIES, calculationCategories);
          console.error('[HPA categories] committed categories', {
            committedLength: calculationCategories.length,
            firstCommitted: calculationCategories[0],
            secondCommitted: calculationCategories[1]
          });
          resolve(calculationCategories);
        }, error => {
          console.error('[HPA categories] error', error);
          logger.error('error=', error);
          reject(error);
        });
    });
  }
};

export const getters = {
  getPreloadVariable: state => state.preloadVariableList,
  getSourceOptions: state => state.sourceList,
  getPageBreakList: state => state.pageBreakList,
  getCalculateList: state => state.calculateVariable,
  getChangeModels: state => state.transformativeChangeModel,
  getSurveys: state => state.surveys,
  getSurveyLists: state => state.surveyLists,
  getSurveyTypes: state => state.surveyTypes,
  getSurveyQuestionList: state => state.surveyQuestions,
  getCurrentSurvey: state => state.currentSurvey,
  getQuestionTypes: state => state.questionTypes,
  getQuestions: state => state.questions,
  getQuestionsInCurrentSurvey: state => state.questions,
  getSelectedChangeModel: state => state.selectedChangeModel,
  getCurrentQuestion (state) {
    return keyword => state.questions.filter(item => {
      return item.title === keyword;
    });
  },
  getQuestionLogics: () => _.cloneDeep(state.currentSurvey.logics),
  getQuestionLogicConditions: () => _.clone(state.currentSurvey.conditions),
  getSurveyDeployments: state => state.surveyDeployments,
  getCopiedSurvey: () => {
    if (state.copiedSurvey) {
      return state.copiedSurvey;
    } else {
      const dataFromLocalStorage = localStorage.getItem('copiedSurvey');
      return dataFromLocalStorage ? JSON.parse(dataFromLocalStorage) : null;
    }
  },
  getQuestionCategories: state => state.questionCategories,
  getHPAScoreCategories: state => state.hpaScoreCategories
};

export const mutations = {
  [SET_PRELOAD_VARIABLE] (currentState, data) {
    currentState.preloadVariableList = data;
  },
  [SET_SOURCE_OPTIONS] (currentState, sourceList) {
    currentState.sourceList = sourceList;
  },
  [SET_CALCULATE_VARIABLE_LIST] (currentState, calculateData) {
    currentState.calculateVariable = calculateData;
  },
  [SET_PAGE_BREAK_LIST] (currentState, pageBreakList) {
    currentState.pageBreakList = pageBreakList;
  },
  [SET_SURVEYS] (currentState, surveys) {
    currentState.surveys = surveys;
  },
  [SET_SURVEY_DETAIL] (currentState, survey) {
    currentState.currentSurvey = _.extend(state.currentSurvey, survey);
    if (!survey.surveyQuestions) {
      const allowToCreateQuestion = currentState.questions.findIndex(q => q.title === '') || true;
      if (allowToCreateQuestion) {
        for (let c = 0; c < currentState.calculateVariable.length; c++) {
          generateCalculateVariable(currentState.questions, currentState.calculateVariable[c]);
        }
        for (let c = 0; c < currentState.pageBreakList.length; c++) {
          addPageBreakToSurveyQuestions(currentState.questions, currentState.pageBreakList[c]);
        }
        questionOrderIndex(currentState);
        generateEmptyQuestion(currentState);
      }
    } else {
      survey.surveyQuestions.forEach(q => {
        q.addedToSurvey = true;
        q.surveyId = survey.id;
      });
      currentState.questions = survey.surveyQuestions;
      for (let i = 0; i < currentState.questions.length; i++) {
        const currentQuestion = currentState.questions[i];
        currentQuestion.enableAduroIndex = survey.specialType === specialType.FLOURING_INDEX;
        if (currentQuestion.groupQuestions) {
          for (let j = 0; j < currentQuestion.groupQuestions.length; j++) {
            const subQuestion = currentQuestion.groupQuestions[j];
            standardSurveyQuestion(currentState, subQuestion);
          }
        } else {
          standardSurveyQuestion(currentState, currentQuestion);
        }
      }
      for (let c = 0; c < currentState.pageBreakList.length; c++) {
        addPageBreakToSurveyQuestions(currentState.questions, currentState.pageBreakList[c]);
      }
      for (let c = 0; c < currentState.calculateVariable.length; c++) {
        generateCalculateVariable(currentState.questions, currentState.calculateVariable[c]);
      }
      questionOrderIndex(currentState);
      generateEmptyQuestion(currentState);
      currentState.currentSurvey.questions = currentState.questions;
      currentState.surveyQuestions = _.cloneDeep(currentState.questions);
    }
  },
  [SET_SURVEY_TYPES] (currentState, surveyTypes) {
    currentState.surveyTypes = surveyTypes;
  },
  [SET_SURVEY_DEPLOYMENTS] (currentState, surveyDeployments) {
    currentState.surveyDeployments = surveyDeployments;
  },
  [SET_SURVEYS_LIST] (currentState, surveyLists) {
    currentState.surveyLists = surveyLists;
  },
  [SET_QUESTION_LIST] (currentState, surveyQuestions) {
    currentState.surveyQuestions = surveyQuestions;
    currentState.questions = surveyQuestions;
  },
  [SET_ADD_CURRENT_SURVEY] (currentState, surveyForm) {
    currentState.currentSurvey = _.extend(currentState.currentSurvey, surveyForm);
  },
  [SET_ADD_QUESTION_TO_SURVEY] (currentState) {
    currentState.currentQuestionIndex += 1;
    const contentType = _.cloneDeep(initQuestionTypesContent);
    const question = {
      title: '',
      question: '',
      surveyQuestionAnswers: [],
      questionResponse: [],
      required: false,
      enableProgramSatisfaction: false,
      fixedRangeDateStatus: false,
      type: 0,
      edit: false,
      preview: false,
      completed: false,
      addedToSurvey: false,
      questionTypesContent: contentType,
      disableCreateQuestionButton: true,
      domainId: null
    };
    if (currentState.questions && currentState.questions.length > 0) {
      const index = currentState.questions.findIndex(q => q.type === 0);
      if (index === -1) {
        currentState.questions.push(question);
      }
    } else {
      currentState.questions.push(question);
    }
  },
  [SET_RESET_CURRENT_SURVEY] (currentState, resetCurrentSurvey) {
    currentState.currentSurvey = resetCurrentSurvey;
  },
  [SET_CHANGE_MODEL] (currentState, transformativeChangeModel) {
    currentState.transformativeChangeModel = transformativeChangeModel;
  },
  [SET_SELECTED_CHANGE_MODEL] (currentState, item) {
    if (item.groupId) {
      const subQuestions = findSubQuestionsInGroup(currentState, item);
      if (subQuestions) {
        const groupQuestionIndex = subQuestions.findIndex(q => q.id === item.id);
        if (groupQuestionIndex === -1) return;
        subQuestions[groupQuestionIndex].selectedChangeModel = item.selectedChangeModel;
      }
      return;
    }
    const index = currentState.questions.findIndex(q => q.question === item.question && q.title === item.title);
    if (index === -1) return;
    currentState.questions[index].selectedChangeModel = item.selectedChangeModel;
  },
  [SET_QUESTION_TYPES] (currentState, questionTypes) {
    currentState.questionTypes = questionTypes;
  },
  [SET_QUESTION_CREATE] (currentState, item) {
    if (!item) {
      const contentType = _.cloneDeep(initQuestionTypesContent);
      const question = {
        title: '',
        question: '',
        surveyQuestionAnswers: [],
        questionResponse: [],
        required: false,
        enableProgramSatisfaction: false,
        fixedRangeDateStatus: false,
        type: 0,
        edit: false,
        preview: false,
        completed: false,
        questionTypesContent: contentType
      };
      // TODO nero 1
      if (currentState.questions && currentState.questions.length > 0) {
        const index = currentState.questions.findIndex(q => q.type === 0);
        if (index === -1) {
          currentState.questions.push(question);
        }
      } else {
        currentState.questions.push(question);
      }
    } else {
      currentState.questions.splice(item.index, 1, item.question);
    }
  },
  [SET_QUESTION_ADD_ANSWER] (currentState, item) {
    const currentQuestion = item;
    if (item.numberOfAnwsers) {
      currentQuestion.surveyQuestionAnswers = [];
      for (let i = 1; i <= item.numberOfAnwsers; i++) {
        const answer = {
          title: `Answer ${currentQuestion.surveyQuestionAnswers.length + 1}`,
          text: '',
          textArea: false,
          value: i
        };
        currentQuestion.surveyQuestionAnswers.push(answer);
      }
    } else {
      const answer = {
        title: `Answer ${currentQuestion.surveyQuestionAnswers.length + 1}`,
        text: '',
        textArea: false
      };
      currentQuestion.surveyQuestionAnswers.push(answer);
    }
  },
  [SET_QUESTION_REMOVE_ANSWER] (currentState, item) {
    const currentQuestion = item;
    if (currentQuestion && currentQuestion.surveyQuestionAnswers) {
      currentQuestion.surveyQuestionAnswers.pop();
    }
  },
  [SET_DELETE_SURVEY] (currentState, item) {
    currentState.surveyLists.splice(
      currentState.surveyLists.findIndex(
        (i) => i.id === item.id
      ), 1);
  },
  [SET_DELETE_QUESTION] (currentState, item) {
    currentState.questions.splice(
      currentState.questions.findIndex(
        (i) => i.id !== undefined && item.id !== undefined ? i.id === item.id : i.title === item.title && i.question === item.question
      ), 1);
    if (currentState.questions.length === 0) {
      // re-create a new question if question list is empty
      const contentType = _.cloneDeep(initQuestionTypesContent);
      const question = {
        title: '',
        question: '',
        surveyQuestionAnswers: [],
        questionResponse: [],
        required: false,
        enableProgramSatisfaction: false,
        fixedRangeDateStatus: false,
        type: 0,
        edit: false,
        preview: false,
        completed: false,
        expand: true,
        questionTypesContent: contentType
      };
      const currentContentIndex = question.questionTypesContent.currentContentIndex;
      const contentLeft = question.questionTypesContent.contentLeft[currentContentIndex];
      // @ts-ignore
      contentLeft.questionTypes = questionTypes;
      currentState.questions.push(question);
    }
  },
  [SET_RESET_QUESTION_LIST] (currentState) {
    currentState.questions = [];
  },
  [SET_SURVEYS_MAP_LIST] (currentState, surveyMaps) {
    currentState.surveyMaps = surveyMaps;
  },
  [SET_ADD_CURRENT_PRACTICE_STEP] (currentState, data) {
    currentState.currentPracticeStep = data;
  },
  [SET_COPY_SURVEY] (currentState, data) {
    currentState.copiedSurvey = data;
  },
  [UPDATE_GROUP_QUESTION_ADD] (currentState, question) {
    const survey = currentState.currentSurvey;
    const groupAndSubQuestions = survey.questions.find(q => q.groupId === survey.currentGroupId && q.groupQuestions);
    if (groupAndSubQuestions) {
      question.groupId = groupAndSubQuestions.groupId;
      question.groupTitle = groupAndSubQuestions.groupTitle;
      groupAndSubQuestions.groupQuestions.push(question);
      currentState.questions.splice(
        currentState.questions.findIndex(
          (i) => i.id === question.id), 1);
    } else {
      const existingGroup = survey.questions.find(q => q.groupId === survey.currentGroupId);
      if (existingGroup) {
        if (!existingGroup.groupQuestions) {
          const subQuestion = _.cloneDeep(existingGroup);
          existingGroup.groupQuestions = [];
          existingGroup.id = existingGroup.groupId;
          existingGroup.groupQuestions.push(subQuestion);
        }
      }
    }
    if (survey.groupQuestionMode && survey.questions) {
      survey.questions.forEach(q => {
        if (q.groupQuestions) {
          q.groupQuestionMode = true;
          q.groupQuestions.forEach(q => {
            q.expand = false;
            q.groupQuestionMode = !survey.groupQuestionMode;
            q.selectedGroup = !survey.groupQuestionMode;
          });
        } else {
          q.expand = !survey.groupQuestionMode;
        }
      });
    }
  },
  [UPDATE_GROUP_QUESTION_REMOVE] (currentState, question) {
    const survey = currentState.currentSurvey;
    const existingGroup = survey.questions.find(q => q.groupId === survey.currentGroupId);
    if (existingGroup && existingGroup.groupQuestions) {
      question.groupId = null;
      question.groupTitle = null;
      existingGroup.groupQuestions.splice(
        existingGroup.groupQuestions.findIndex(
          (i) => i.id === question.id), 1);
      currentState.questions.push(question);
      currentState.questions = _.orderBy(currentState.questions, ['orderIndex'], ['asc']);
      currentState.currentSurvey.questions = currentState.questions;
    }
  },
  [SET_SURVEY_HPA_SCORE_CATEGORIES] (currentState, categories) {
    currentState.hpaScoreCategories = categories;
  }
};

export default {
  state,
  actions,
  getters,
  mutations,
  standardSurveyData
};
